import { TableConfigV2, Column } from 'hooks/useMuiTableBuilderV2';
/* ---------------------------------- Data ---------------------------------- */
import DataTypeDataCell from './Cells/Data/DataTypeDataCell';
import CountDataCell from './Cells/Data/CountDataCell';
import LastSyncTimeDataCell from './Cells/Data/LastSyncTimeDataCell';
import MostRecentUpdateDataCell from './Cells/Data/MostRecentUpdateDataCell';
import omit from 'lodash/omit';
import { ValueOf } from 'type-fest';
import { HeaderCell } from 'components/Cells/HeaderCell';

export const stateId = 'mapping-status-per-data-type-table';

export enum TableVariants {
  DEFAULT = 'default',
}

export const COLUMNS = {
  DATA_TYPE: 'dataType',
  COUNT: 'count',
  MOST_RECENT_UPDATE: 'mostRecentUpdate',
  LAST_SYNC_TIME: 'lastSyncTime',
};

export const ROW_TYPES = {
  HEADER: 'HEADER',
  DATA: 'DATA',
};

const dataTypeColumn: Column = {
  id: COLUMNS.DATA_TYPE,
  label: 'Data Type',
};

const countColumn: Column = {
  id: COLUMNS.COUNT,
  label: 'Counts',
};

const mostRecentUpdateColumn: Column = {
  id: COLUMNS.MOST_RECENT_UPDATE,
  label: 'Last Updated',
  tooltip: 'Most recent update for this data type in IS.',
};

const lastTimeSyncColumn: Column = {
  id: COLUMNS.LAST_SYNC_TIME,
  label: 'Last Synced',
  tooltip: 'Last sync time from the agent, indicating when the last fetch occurred.',
};

const tableConfigs = {
  [TableVariants.DEFAULT]: {},
};

export const getTableConfig = ({
  variant = TableVariants.DEFAULT,
}: {
  variant?: ValueOf<typeof TableVariants>;
}): TableConfigV2 => {
  const variantConfig = tableConfigs[variant];
  const customConfigToUse = omit(variantConfig, 'cellsByRowTypesAndColumns');
  const config = {
    /* --------------------------------- Shared --------------------------------- */
    hasStickyHeader: true,
    tableHeaderTitle: '',
    rowTypes: ROW_TYPES,
    tableMaxHeight: '21rem',
    hideToolbar: true,
    columns: [dataTypeColumn, countColumn, mostRecentUpdateColumn, lastTimeSyncColumn],
    columnsMinWidth: {
      [COLUMNS.DATA_TYPE]: 100,
      [COLUMNS.COUNT]: 100,
      [COLUMNS.MOST_RECENT_UPDATE]: 200,
      [COLUMNS.LAST_SYNC_TIME]: 200,
    },
    cellsByRowTypesAndColumns: {
      [ROW_TYPES.DATA]: {
        [COLUMNS.DATA_TYPE]: DataTypeDataCell,
        [COLUMNS.COUNT]: CountDataCell,
        [COLUMNS.MOST_RECENT_UPDATE]: MostRecentUpdateDataCell,
        [COLUMNS.LAST_SYNC_TIME]: LastSyncTimeDataCell,
      },
      [ROW_TYPES.HEADER]: {
        [COLUMNS.DATA_TYPE]: HeaderCell,
        [COLUMNS.COUNT]: HeaderCell,
        [COLUMNS.MOST_RECENT_UPDATE]: HeaderCell,
        [COLUMNS.LAST_SYNC_TIME]: HeaderCell,
      },
    },
    /* -------------------------------- Variant  ------------------------------- */
    ...customConfigToUse,
  };

  return config;
};
